import React from "react";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListSubheader from "@material-ui/core/ListSubheader";
import withStyles from "@material-ui/core/styles/withStyles";
import PropertySection from "../property/PropertySection";
import memoAssign from "../../util/memoAssign";
import { AddPropertyFieldComponent } from "../property/PropertyField";

export const SectionListField = withStyles(
  {
    panelDetailsRoot: {
      flexDirection: "column"
    },
    closeMenuIcon: {
      marginLeft: "auto"
    },
    summaryContent: {
      //margin: 0
    },
    summaryContentExpanded: {
      //margin: "0 !important",
      //minHeight: "unset !important"
    },
    listItemRoot: {
      display: "inherit",
      padding: 0
      //flexDirection: "column"
    }
  },
  { name: "LcSectionListField" }
)(
  function SectionListField({
    classes,
    //name,
    fieldInfo = {},
    sections = [],
    //add: { icon: FieldAddIcon = AddIcon, label: addLabel = "Add" } = {},
    //delete: {
    //icon: FieldDeleteIcon = DeleteForeverIcon
    //label: deleteLabel = () => "Delete"
    //} = {},
    //max = -1,
    header = {
      //paddingBottom: 1
    },
    section = {
      //paddingBottom: 0,
      //marginBottom: 2,
      //marginRight: 1,
      //border: 1,
      //borderColor: "#ced4da",
      //padding: 2,
      //borderRadius: ".25rem"
    },
    field = {
      //padding: 0.25,
      //paddingBottom: 1
    },
    //readOnly = false,
    //defaultValues = {},
    //disabled,
    //direction = "row",
    //title = {
    //layout: [["title"]],
    //fieldInfo: {
    //title: {
    //label: "Title"
    //}
    //}
    //},
    //hideRemove,
    //dense,
    //sticky,
    j = 0
    //value
  }) {
    //const items = getIn(formik.values, name) || value || [];
    //const dis = formik.isSubmitting || formik.isValidating || disabled;

    const dis = false;

    const form =
      sections &&
      sections.map(
        ({
          subheader,
          hidden,
          box = {},
          field: sectionField = {},
          header: sectionHeader = {},
          ...sectionEntry
        }) => {
          const shouldHide = false;
          //hidden !== undefined && hidden(formik.values, formik);

          return (
            <React.Fragment key={j++}>
              {subheader ? (
                <ListSubheader>
                  <PropertySection
                    disabled={dis}
                    shouldHide={shouldHide}
                    fieldInfo={fieldInfo}
                    {...sectionEntry}
                    header={memoAssign(header, sectionHeader)}
                    field={memoAssign(field, sectionField)}
                    section={memoAssign(section, box)}
                  />
                </ListSubheader>
              ) : (
                <ListItem
                  disableGutters
                  alignItems="flex-start"
                  classes={{ root: classes.listItemRoot }}
                >
                  <PropertySection
                    disabled={dis}
                    shouldHide={shouldHide}
                    fieldInfo={fieldInfo}
                    {...sectionEntry}
                    header={memoAssign(header, sectionHeader)}
                    field={memoAssign(field, sectionField)}
                    section={memoAssign(section, box)}
                  />
                </ListItem>
              )}
            </React.Fragment>
          );
        }
      );

    return (
      <List dense disablePadding>
        {form}
      </List>
    );
  } //)
);

AddPropertyFieldComponent("sectionlist", SectionListField);

export default SectionListField;
